"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMapType = exports.useMapInstance = exports.useMapEvents = exports.mapTypes = exports["default"] = exports.MapTypeContext = exports.MapInstanceContext = exports.MapEventContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactMapGl = _interopRequireWildcard(require("react-map-gl"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _googleMapReact = _interopRequireDefault(require("google-map-react"));

var _useMap = require("./hooks/use-map");

require("mapbox-gl/dist/mapbox-gl.css");

var _excluded = ["zoom"];

var _ENV$mapTiles$road, _ENV, _ENV$mapTiles;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var tilesURL = (_ENV$mapTiles$road = (_ENV = ENV) === null || _ENV === void 0 ? void 0 : (_ENV$mapTiles = _ENV.mapTiles) === null || _ENV$mapTiles === void 0 ? void 0 : _ENV$mapTiles.road) !== null && _ENV$mapTiles$road !== void 0 ? _ENV$mapTiles$road : 'https://tiles.geo.nic-place.com/osm_tiles/{z}/{x}/{y}.png';
var mapTypes = {
  google: 'google',
  osm: 'osm'
};
exports.mapTypes = mapTypes;
var MapTypeContext = /*#__PURE__*/(0, _react.createContext)(mapTypes.google);
exports.MapTypeContext = MapTypeContext;

var useMapType = function useMapType() {
  var mapType = (0, _react.useContext)(MapTypeContext);
  return {
    mapType: mapType,
    types: mapTypes
  };
};

exports.useMapType = useMapType;
var defaultMapInstances = {
  google: null,
  osm: null
};
var MapInstanceContext = /*#__PURE__*/(0, _react.createContext)(defaultMapInstances);
exports.MapInstanceContext = MapInstanceContext;

var useMapInstance = function useMapInstance() {
  return (0, _react.useContext)(MapInstanceContext);
};

exports.useMapInstance = useMapInstance;
var MapEventContext = /*#__PURE__*/(0, _react.createContext)(function () {});
exports.MapEventContext = MapEventContext;

var useMapEvents = function useMapEvents(layerId) {
  var _useContext = (0, _react.useContext)(MapEventContext),
      onClick = _useContext.onClick,
      onMouseUp = _useContext.onMouseUp,
      onMouseDown = _useContext.onMouseDown,
      onHover = _useContext.onHover;

  return {
    onClick: (0, _react.useCallback)(function (_ref) {
      var latitude = _ref.latitude,
          longitude = _ref.longitude;
      return onClick({
        layerId: layerId,
        latitude: latitude,
        longitude: longitude
      });
    }, [layerId, onClick]),
    onMouseUp: (0, _react.useCallback)(function (_ref2) {
      var latitude = _ref2.latitude,
          longitude = _ref2.longitude;
      return onMouseUp({
        layerId: layerId,
        latitude: latitude,
        longitude: longitude
      });
    }, [layerId, onMouseUp]),
    onMouseDown: (0, _react.useCallback)(function (_ref3) {
      var latitude = _ref3.latitude,
          longitude = _ref3.longitude;
      return onMouseDown({
        layerId: layerId,
        latitude: latitude,
        longitude: longitude
      });
    }, [layerId, onMouseDown]),
    onHover: (0, _react.useCallback)(function (_ref4) {
      var latitude = _ref4.latitude,
          longitude = _ref4.longitude;
      return onHover({
        layerId: layerId,
        latitude: latitude,
        longitude: longitude
      });
    }, [layerId, onHover])
  };
};

exports.useMapEvents = useMapEvents;
var mapStyle = {
  version: 8,
  sources: {},
  layers: []
};

var BaseMap = function BaseMap(_ref5) {
  var _mapInstances$google, _ENV$google, _ENV$google$maps;

  var children = _ref5.children,
      height = _ref5.height,
      width = _ref5.width,
      zoom = _ref5.zoom,
      minZoom = _ref5.minZoom,
      maxZoom = _ref5.maxZoom,
      latitude = _ref5.latitude,
      longitude = _ref5.longitude,
      mapType = _ref5.mapType,
      _onViewportChange = _ref5.onViewportChange,
      hideFullscreenControl = _ref5.hideFullscreenControl,
      hideZoomControl = _ref5.hideZoomControl,
      interactiveLayerIds = _ref5.interactiveLayerIds,
      _onClick = _ref5.onClick,
      _onMouseDown = _ref5.onMouseDown,
      _onMouseUp = _ref5.onMouseUp,
      _onHover = _ref5.onHover;
  // this ref keeps track, if google fired its first onChange (which will be ignored)
  // For more info see: https://github.com/google-map-react/google-map-react/issues/426
  var isStupidGoogleChangeTriggered = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    // reset value, when mapType change.
    isStupidGoogleChangeTriggered.current = false;
  }, [mapType]);

  var _useState = (0, _react.useState)(defaultMapInstances),
      _useState2 = _slicedToArray(_useState, 2),
      mapInstances = _useState2[0],
      setMapInstances = _useState2[1];

  var setRef = (0, _react.useCallback)(function (ref) {
    setMapInstances({
      google: null,
      osm: ref === null || ref === void 0 ? void 0 : ref.getMap()
    });
  }, []);
  var mapEvents = (0, _react.useMemo)(function () {
    var adaptLayerEvent = function adaptLayerEvent(eventHandler) {
      return function (event) {
        return eventHandler(_objectSpread(_objectSpread({}, event), {}, {
          layerId: interactiveLayerIds.includes(event.layerId) ? event.layerId : null
        }));
      };
    };

    return {
      onClick: adaptLayerEvent(_onClick),
      onHover: adaptLayerEvent(_onHover),
      onMouseDown: adaptLayerEvent(_onMouseDown),
      onMouseUp: adaptLayerEvent(_onMouseUp)
    };
  }, [interactiveLayerIds, _onClick, _onHover, _onMouseDown, _onMouseUp]);
  var onGoogleMapClick = (0, _react.useCallback)(function (_ref6) {
    var latLng = _ref6.latLng;
    return mapEvents.onClick({
      layerId: null,
      latitude: latLng.lat(),
      longitude: latLng.lng()
    });
  }, [mapEvents]);
  var onGoogleMapMouseDown = (0, _react.useCallback)(function (_ref7) {
    var latLng = _ref7.latLng;
    return mapEvents.onMouseDown({
      layerId: null,
      latitude: latLng.lat(),
      longitude: latLng.lng()
    });
  }, [mapEvents]);
  var onGoogleMapMouseUp = (0, _react.useCallback)(function (_ref8) {
    var latLng = _ref8.latLng;
    return mapEvents.onMouseUp({
      layerId: null,
      latitude: latLng.lat(),
      longitude: latLng.lng()
    });
  }, [mapEvents]);
  var onGoogleMapHover = (0, _react.useCallback)(function (_ref9) {
    var latLng = _ref9.latLng;
    mapEvents.onHover({
      layerId: null,
      latitude: latLng.lat(),
      longitude: latLng.lng()
    });
  }, [mapEvents]);
  var google = (_mapInstances$google = mapInstances.google) !== null && _mapInstances$google !== void 0 ? _mapInstances$google : {};
  (0, _react.useEffect)(function () {
    var handleMouseMove;
    var handleMouseDown;
    var handleMouseUp;
    var handleClick;

    if (google.map) {
      handleClick = google.map.addListener('click', onGoogleMapClick);
      handleMouseMove = google.map.addListener('mousemove', onGoogleMapHover);
      handleMouseDown = google.map.addListener('mousedown', onGoogleMapMouseDown);
      handleMouseUp = google.map.addListener('mouseup', onGoogleMapMouseUp);
    }

    return function () {
      if (google.maps && handleClick) {
        google.maps.event.removeListener(handleClick);
      }

      if (google.maps && handleMouseMove) {
        google.maps.event.removeListener(handleMouseMove);
      }

      if (google.maps && handleMouseDown) {
        google.maps.event.removeListener(handleMouseDown);
      }

      if (google.maps && handleMouseUp) {
        google.maps.event.removeListener(handleMouseUp);
      }
    };
  }, [google.map, google.maps, onGoogleMapClick, onGoogleMapHover, onGoogleMapMouseDown, onGoogleMapMouseUp]);
  return /*#__PURE__*/_react["default"].createElement(MapTypeContext.Provider, {
    value: mapType
  }, /*#__PURE__*/_react["default"].createElement(MapInstanceContext.Provider, {
    value: mapInstances
  }, /*#__PURE__*/_react["default"].createElement(MapEventContext.Provider, {
    value: mapEvents
  }, mapType === 'google' ? /*#__PURE__*/_react["default"].createElement(_googleMapReact["default"], {
    style: {
      height: height,
      width: width
    },
    bootstrapURLKeys: {
      key: (_ENV$google = ENV.google) === null || _ENV$google === void 0 ? void 0 : (_ENV$google$maps = _ENV$google.maps) === null || _ENV$google$maps === void 0 ? void 0 : _ENV$google$maps.key,
      // client:'gme-fourkitesinc',
      // language: props.language,
      libraries: 'geometry,visualization,drawing'
    },
    options: function options(map) {
      return {
        panControl: false,
        mapTypeControl: true,
        scaleControl: true,
        fullscreenControl: !hideFullscreenControl,
        zoomControl: !hideZoomControl,
        mapTypeControlOptions: {
          style: map.MapTypeControlStyle.DEFAULT,
          position: map.ControlPosition.LEFT_BOTTOM
        },
        minZoom: minZoom + 1,
        maxZoom: maxZoom + 1
      };
    },
    yesIWantToUseGoogleMapApiInternals: true,
    center: {
      lat: latitude,
      lng: longitude
    },
    zoom: Math.round(zoom) + 1,
    resetBoundsOnResize: true,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref10) {
      var map = _ref10.map,
          maps = _ref10.maps;
      setMapInstances({
        osm: null,
        google: {
          map: map,
          maps: maps
        }
      });
    },
    onChange: function onChange(_ref11) {
      var newCenter = _ref11.center,
          newZoom = _ref11.zoom,
          newSize = _ref11.size;

      // first onChange has to be ignored, only subsequent changes should be processed.
      // For more info see: https://github.com/google-map-react/google-map-react/issues/426
      if (!isStupidGoogleChangeTriggered.current) {
        isStupidGoogleChangeTriggered.current = true;
        return;
      }

      _onViewportChange({
        zoom: newZoom - 1,
        latitude: newCenter.lat,
        longitude: newCenter.lng,
        height: newSize.height,
        width: newSize.width
      });
    }
  }, children) : /*#__PURE__*/_react["default"].createElement(_reactMapGl["default"], {
    ref: setRef,
    onClick: function onClick(event) {
      var _event$features;

      var featureForEvent = (_event$features = event.features) === null || _event$features === void 0 ? void 0 : _event$features.find(function (item) {
        return interactiveLayerIds.includes(item.layer.id);
      });

      var _event$lngLat = _slicedToArray(event.lngLat, 2),
          lng = _event$lngLat[0],
          lat = _event$lngLat[1];

      if (featureForEvent) {
        var layerId = featureForEvent.layer.id;

        _onClick({
          layerId: layerId,
          latitude: lat,
          longitude: lng
        });
      } else {
        _onClick({
          layerId: null,
          latitude: lat,
          longitude: lng
        });
      }
    },
    onMouseDown: function onMouseDown(event) {
      var _event$lngLat2 = _slicedToArray(event.lngLat, 2),
          lng = _event$lngLat2[0],
          lat = _event$lngLat2[1];

      _onMouseDown({
        layerId: null,
        latitude: lat,
        longitude: lng
      });
    },
    onMouseUp: function onMouseUp(event) {
      var _event$lngLat3 = _slicedToArray(event.lngLat, 2),
          lng = _event$lngLat3[0],
          lat = _event$lngLat3[1];

      _onMouseUp({
        layerId: null,
        latitude: lat,
        longitude: lng
      });
    },
    onHover: function onHover(event) {
      var _event$features2;

      var featureForEvent = (_event$features2 = event.features) === null || _event$features2 === void 0 ? void 0 : _event$features2.find(function (item) {
        return interactiveLayerIds.includes(item.layer.id);
      });

      var _event$lngLat4 = _slicedToArray(event.lngLat, 2),
          lng = _event$lngLat4[0],
          lat = _event$lngLat4[1];

      if (featureForEvent) {
        var layerId = featureForEvent.layer.id;

        _onHover({
          layerId: layerId,
          latitude: lat,
          longitude: lng
        });
      } else {
        _onHover({
          layerId: null,
          latitude: lat,
          longitude: lng
        });
      }
    },
    interactiveLayerIds: interactiveLayerIds,
    disableTokenWarning: true,
    mapStyle: mapStyle,
    height: height,
    width: width,
    zoom: Math.min(Math.max(zoom, minZoom), maxZoom),
    minZoom: minZoom,
    maxZoom: maxZoom,
    latitude: latitude,
    longitude: longitude,
    onViewportChange: function onViewportChange(viewport) {
      _onViewportChange(_objectSpread({}, viewport));
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactMapGl.Source, {
    type: "raster",
    tileSize: 256,
    tiles: [tilesURL],
    attribution: "&copy <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors"
  }, /*#__PURE__*/_react["default"].createElement(_reactMapGl.Layer, {
    type: "raster"
  })), children, !hideFullscreenControl && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-8 top-1 mt-1 mr-1 z-10"
  }, /*#__PURE__*/_react["default"].createElement(_reactMapGl.FullscreenControl, null)), !hideZoomControl && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-8 bottom-16 mb-10 mr-1 z-10"
  }, /*#__PURE__*/_react["default"].createElement(_reactMapGl.NavigationControl, {
    showCompass: false,
    onViewportChange: function onViewportChange(_ref12) {
      var newZoom = _ref12.zoom,
          other = _objectWithoutProperties(_ref12, _excluded);

      return _onViewportChange(_objectSpread(_objectSpread({}, other), {}, {
        zoom: Math.min(Math.max(newZoom, minZoom), maxZoom)
      }));
    }
  }))))));
};

var noop = function noop() {};

BaseMap.propTypes = {
  children: _propTypes["default"].node,
  mapType: _propTypes["default"].oneOf([mapTypes.osm, mapTypes.google]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  zoom: _propTypes["default"].number,
  minZoom: _propTypes["default"].number,
  maxZoom: _propTypes["default"].number,
  latitude: _propTypes["default"].number,
  longitude: _propTypes["default"].number,
  onViewportChange: _propTypes["default"].func,
  hideZoomControl: _propTypes["default"].bool,
  hideFullscreenControl: _propTypes["default"].bool,
  interactiveLayerIds: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onClick: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onHover: _propTypes["default"].func
};
BaseMap.defaultProps = {
  children: null,
  height: '100%',
  width: '100%',
  mapType: mapTypes.google,
  zoom: _useMap.defaultViewport.zoom,
  minZoom: _useMap.defaultViewport.minZoom,
  maxZoom: _useMap.defaultViewport.maxZoom,
  latitude: _useMap.defaultViewport.latitude,
  longitude: _useMap.defaultViewport.longitude,
  onViewportChange: noop,
  hideZoomControl: false,
  hideFullscreenControl: false,
  interactiveLayerIds: [],
  onClick: noop,
  onMouseDown: noop,
  onMouseUp: noop,
  onHover: noop
};
var _default = BaseMap;
exports["default"] = _default;